$("#new-rating").on("show.bs.modal", function (event) {
    const defaultStarsEl = document.querySelector(".js-default-stars");
    const defaultStarsRating = defaultStarsEl.querySelector(".js-star-rating-full").dataset.rating;
    const defaultStarsValue = defaultStarsEl.querySelector('[name="rating"]:checked').value;

    const modalStarsEl = document.querySelector(".js-modal-stars");

    modalStarsEl.querySelector(".js-star-rating-full").dataset.rating = defaultStarsRating;
    modalStarsEl.querySelector(`[name="rating"][value="${defaultStarsValue}"]`).checked = true;
});

const urlHash = window.location.hash;

$(function () {
    if (urlHash == "#new-rating") {
        $("#new-rating").modal("show");
    }
});
